import { useState, useCallback } from "react";
import { UseFormReturn } from "react-hook-form";
import { Autorenew as RelativeTimeIcon, Event as CalendarIcon, Groups2 } from "@mui/icons-material";
import { findField } from "../../utils/findField";
import { renderFieldInput } from "../fieldsInputs/renderFieldInput";
import { RecordsContextType } from "../records/Records";
import { getFieldExtraOption } from "../../utils/getFieldExtraOption";
import { DynamicDateValueFields } from "./dynamic-fields/DynamicDateValueFields";
import { DynamicUserValueField } from "./dynamic-fields/DynamicUserValueField";
import { SwitcherInputs } from "../switchers/SwitcherInputs";
import { DYNAMIC_AND_STATIC_DATE_OPERATORS, isDynamicDateValue } from "./dynamic-fields/dynamicDateUtils";
import { OPERATORS_WITH_TRUE_AS_VALUE } from "./Filters";
import { DYNAMIC_USER_FIELDS, isDynamicUserFilter } from "./dynamic-fields/dynamicUserUtils";

type FilterFieldValueProps = {
    context: RecordsContextType;
    index: number;
    entityForm: UseFormReturn;
};


export const FilterFieldValue = ({ context, index, entityForm }: FilterFieldValueProps) => {
    const watchedFields = entityForm.watch();
    const currentOperator = watchedFields.filters[index]?.operator;
    const currentValue = watchedFields.filters[index]?.value;

    const [inputMode, setInputMode] = useState<"default" | "alternative" | null>(getInitialMode(currentValue));

    const toggleInputMode = useCallback((inputMode: "default" | "alternative" | null) => {
        setInputMode(inputMode);
        entityForm.setValue(`filters.${index}.value`, []);
    }, [entityForm, index]);
    
    if (!context?.formatedFields) return null;

    const fieldToRender = findField(context?.formatedFields, watchedFields.filters[index].field.field);
    
    if (!fieldToRender) return null;

    const extraOptions = context?.options?.groupsOptions?.fieldsWithExtraOptions;
    const fieldExtraOptions = context?.options && extraOptions ? getFieldExtraOption(extraOptions, fieldToRender) : null;

    const isDynamicDateFilter = DYNAMIC_AND_STATIC_DATE_OPERATORS.includes(currentOperator);
    const isDynamicUserFilter = DYNAMIC_USER_FIELDS.includes(fieldToRender?.field)

    const noValueNeeded = OPERATORS_WITH_TRUE_AS_VALUE.includes(currentOperator);

    const { relatedMany2ManyLimit, ...filterExtraOptions } = fieldExtraOptions || {};

    const renderDefaultFieldInput = renderFieldInput(fieldToRender, specialCases(), "filter", entityForm, {
        ...filterExtraOptions,
        field: `filters.${index}.value`,
        disabled: noValueNeeded,
    });

    if (isDynamicDateFilter) {
        return (
            <SwitcherInputs 
            renderDefaultInput={renderDefaultFieldInput}
            renderAlternativeInput={<DynamicDateValueFields entityForm={entityForm} index={index} />}
            defaultIcon={<CalendarIcon fontSize="small" />}
            alternativeIcon={<RelativeTimeIcon fontSize="small" />}
            defaultLabel="Fixo"
            alternativeLabel="Relativo"
            inputMode={inputMode}
            toggleInputMode={toggleInputMode}
        />
        )
    }
    if (isDynamicUserFilter) {
        return (
            <SwitcherInputs
            renderDefaultInput={renderDefaultFieldInput}
            renderAlternativeInput={<DynamicUserValueField entityForm={entityForm} index={index} field={fieldToRender.field}/>}
            defaultIcon={<Groups2 fontSize="small" />}
            alternativeIcon={<RelativeTimeIcon fontSize="small" />}
            defaultLabel="Fixo"
            alternativeLabel="Relativo"
            inputMode={inputMode}
            toggleInputMode={toggleInputMode}
        />
        )
    }

    return renderDefaultFieldInput;
};

const specialCases = () => {
    return null;
};

const getInitialMode = (currentValue: string | {} | null): "default" | "alternative" | null => {
    if (!currentValue) return "default";
    if (typeof currentValue === "string" && isDynamicDateValue(currentValue)) {
        return "alternative";
    }
    if (isDynamicUserFilter(currentValue)) return "alternative"
    
    return "default";
}

